import React, { useEffect, useState } from "react";
import {
  ActionIcon,
  Button,
  Modal,
  Skeleton,
  Text,
  TextInput,
} from "@mantine/core";
import { IconFolder, IconArrowLeft } from "@tabler/icons-react";
import {
  createFolderNameApi,
  getFoldersNames,
  getSubFoldersApi,
} from "../../utilities/apis/commonApis";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import NewDocumentUploader from "./NewDocumentUploader";
import useMultiFileUpload from "../../hooks/useMultiFileUpload";

const ViewFiles = ({ parent, parentId }) => {
  const [loading, setLoading] = useState(true);
  const [folders, setFolders] = useState([]);
  const [newFolderName, setNewFolderName] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Track folder path: array of { id, name }
  const [folderStack, setFolderStack] = useState([]);

  const currentFolder = folderStack[folderStack.length - 1];

  const multiUploadArgs = useMultiFileUpload({
    loadFromParent: true,
    parentId,
    parent: "agreement",
    folderId: currentFolder?.id,
  });

  // Fetch folders whenever folderStack changes
  const fetchFolders = async () => {
    setLoading(true);
    let response;
    if (currentFolder?.id) {
      response = await apiWrapWithErrorWithData(
        getSubFoldersApi({ parentFolder: currentFolder.id })
      );
    } else {
      response = await apiWrapWithErrorWithData(
        getFoldersNames({ parent, parentId })
      );
    }
    if (response.success) {
      setFolders(response.folders || []);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchFolders();
  }, [folderStack]);

  // Create a new folder in the current folder
  const handleCreateFolder = async () => {
    if (!newFolderName.trim()) return;

    const response = await apiWrapWithErrorWithData(
      createFolderNameApi({
        agreementId: parentId,
        name: newFolderName.trim(),
        parentFolder: currentFolder?.id, // undefined if root
      })
    );
    if (response.success) {
      setShowModal(false);
      setNewFolderName("");
      fetchFolders();
    }
  };

  return (
    <div>
      {loading ? (
        <div className="flex flex-col my-4">
          <div className="flex justify-end">
            <Skeleton height={30} radius="md" className="my-1 w-60" />
          </div>
          {Array.from({ length: 6 }).map((_, idx) => (
            <Skeleton key={idx} height={30} radius="md" className="my-1 w-full" />
          ))}
        </div>
      ) : (
        <div>
          <div className="flex justify-start items-center mb-4">
            <Text>{`Files for agreement ${parentId}`}</Text>
            {/* <Button onClick={() => setShowModal(true)}>Add folder</Button> */}
          </div>

          {/* Breadcrumb / current path */}
          {folderStack.length > 0 && (
            <div className="flex items-center gap-2 mb-4">
              <IconArrowLeft
                size={20}
                className="cursor-pointer"
                onClick={() => setFolderStack(folderStack.slice(0, -1))}
              />
              {folderStack.map((folder, idx) => (
                <React.Fragment key={folder.id}>
                  <Text
                    className="cursor-pointer"
                    onClick={() => setFolderStack(folderStack.slice(0, idx + 1))}
                  >
                    {folder.name}
                  </Text>
                  {idx < folderStack.length - 1 && <Text>{">"}</Text>}
                </React.Fragment>
              ))}
            </div>
          )}

          {/* List folders */}
          {folders.length > 0 ? (
            <div className="space-y-3">
              {folders.map((folder) => (
                <div
                  key={folder.id}
                  onClick={() =>
                    setFolderStack([...folderStack, { id: folder.id, name: folder.name }])
                  }
                  className="flex items-center gap-3 cursor-pointer"
                >
                  <IconFolder color="#46BDE1" size={25} />
                  <Text>{folder.name}</Text>
                </div>
              ))}
            </div>
          ) : (
            <Text color="dimmed">No folders found.</Text>
          )}
          {/* {currentFolder &&  */}
          <div className="mt-6">
            <NewDocumentUploader multiUploadArgs={multiUploadArgs} />
          </div>


        </div>
      )}

      {/* Modal to create new folder */}
      <Modal
        opened={showModal}
        title="Add new folder"
        onClose={() => setShowModal(false)}
      >
        <TextInput
          label="Folder name"
          placeholder="Enter folder name"
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
        />
        <div className="flex justify-end mt-4">
          <Button
            onClick={handleCreateFolder}
            disabled={!newFolderName.trim()}
          >
            Add
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ViewFiles;
